/* ============================================================
   MUSE DISC — Product Hero JS
   Gallery thumbnails + variant switching + quantity + ATC
   ============================================================ */

(function () {
  const section   = document.getElementById('product-hero');
  if (!section) return;

  // --- Gallery thumbnails ----------------------------------
  const mainImg   = document.getElementById('ph-main-image');
  const thumbs    = section.querySelectorAll('.ph__thumb');

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.dataset.src;
      const alt = thumb.dataset.alt;

      if (mainImg && src) {
        // Fade out → swap → fade in
        mainImg.style.opacity = '0';
        mainImg.style.transition = 'opacity 0.2s';
        setTimeout(() => {
          mainImg.src = src;
          mainImg.alt = alt;
          mainImg.style.opacity = '1';
        }, 200);
      }

      thumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  // --- Gallery arrows + swipe -----------------------------
  const prevBtn    = document.getElementById('ph-prev');
  const nextBtn    = document.getElementById('ph-next');
  const thumbsArr  = Array.from(thumbs);

  if (thumbsArr.length > 1) {
    let currentIndex = 0;

    // Keep index in sync when any thumb is clicked (arrow or direct)
    thumbsArr.forEach((thumb, i) => {
      thumb.addEventListener('click', () => { currentIndex = i; });
    });

    function goTo(index) {
      const count = thumbsArr.length;
      currentIndex = (index + count) % count;
      thumbsArr[currentIndex].click();
    }

    if (prevBtn) prevBtn.addEventListener('click', () => goTo(currentIndex - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(currentIndex + 1));

    // Swipe support
    const wrap = document.getElementById('ph-main-wrap');
    if (wrap) {
      let touchStartX = 0;
      wrap.addEventListener('touchstart', e => {
        touchStartX = e.changedTouches[0].clientX;
      }, { passive: true });
      wrap.addEventListener('touchend', e => {
        const delta = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(delta) >= 50) goTo(currentIndex + (delta < 0 ? 1 : -1));
      }, { passive: true });
    }
  }

  // --- Variant switching -----------------------------------
  const radios    = section.querySelectorAll('.ph__option-radio');
  const variantId = document.getElementById('ph-variant-id');
  const priceEl   = document.getElementById('ph-price');
  const atcBtn    = document.getElementById('ph-atc');

  radios.forEach(radio => {
    radio.addEventListener('change', () => {
      // Highlight selected label
      section.querySelectorAll('.ph__option-btn').forEach(btn => {
        btn.classList.toggle('is-selected', btn.querySelector('input')?.checked);
      });

      // Find matching variant via Shopify's global product JSON
      const selected = Array.from(section.querySelectorAll('.ph__option-radio:checked'))
        .map(r => r.value);

      const variant = findVariant(selected);
      if (!variant) return;

      // Update hidden input
      if (variantId) variantId.value = variant.id;

      // Update price
      if (priceEl) {
        const price    = formatMoney(variant.price);
        const compare  = variant.compare_at_price > variant.price
          ? `<span class="ph__price-compare">${formatMoney(variant.compare_at_price)}</span>`
          : '';
        priceEl.innerHTML = `<span class="ph__price-current">${price}</span>${compare}`;
      }

      // Update ATC button
      if (atcBtn) {
        atcBtn.disabled = !variant.available;
        atcBtn.textContent = variant.available ? 'ADD TO CART →' : 'SOLD OUT';
      }

      // Update URL without reload
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    });
  });

  function findVariant(selectedOptions) {
    const productData = window.__productData;
    if (!productData) return null;
    return productData.variants.find(v =>
      v.options.every((opt, i) => opt === selectedOptions[i])
    );
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('en-EU', {
      style: 'currency',
      currency: window.__currency || 'EUR',
      minimumFractionDigits: 0,
    });
  }

  // --- Quantity selector -----------------------------------
  const qtyInput  = document.getElementById('ph-qty');
  const qtyBtns   = section.querySelectorAll('.ph__qty-btn');

  qtyBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const current = parseInt(qtyInput.value, 10) || 1;
      const action  = btn.dataset.action;
      qtyInput.value = action === 'plus'
        ? current + 1
        : Math.max(1, current - 1);
    });
  });

  // --- ATC via AJAX ----------------------------------------
  const form = section.querySelector('form');
  if (form && atcBtn) {
    form.addEventListener('submit', e => {
      e.preventDefault();

      const id  = parseInt(document.getElementById('ph-variant-id')?.value, 10);
      const qty = parseInt(document.getElementById('ph-qty')?.value, 10) || 1;
      if (!id) return;

      atcBtn.textContent = 'Adding…';
      atcBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, quantity: qty }),
      })
        .then(r => r.json())
        .then(() => {
          atcBtn.textContent = 'ADDED ✓';
          document.dispatchEvent(new CustomEvent('cart:open'));
          setTimeout(() => {
            atcBtn.disabled = false;
            atcBtn.textContent = 'ADD TO CART →';
          }, 1800);
        })
        .catch(() => {
          atcBtn.disabled = false;
          atcBtn.textContent = 'ADD TO CART →';
        });
    });
  }
})();
